export const taxs_details = [
  {
    key:"1",
    Tax_Name: "VAT",
    Tax_Percentage: "20%",
    Status: "Active",
  },
  {
    key:"2",
    Tax_Name: "GST",
    Tax_Percentage: "18%",
    Status: "Active",
  },
  {
    key:"3",
    Tax_Name: "Income Tax",
    Tax_Percentage: "30%",
    Status: "Inactive",
  },
  {
    key:"4",
    Tax_Name: "Corporate Tax",
    Tax_Percentage: "25%",
    Status: "Inactive",
  },
];
